import React, {Component} from "react";
import {SanitizeClassNames} from "../../../common";
import {FormDataObj, FormLabeledItem, Input, Button} from "../../../components/FormUI";
import ClinicPatientList from "../../../components/datalists/ClinicPatientList";

import './ClientLinkForm.css';
import RootModal from "../../../components/RootModal";
import UserMiniForm from "./UserMiniForm";
import ExtAppService from "../../../api/services/ExtAppService";
import Helper from "../../../classes/Helper";

export default class ClientLinkForm extends Component {
	constructor(props) {
		super(props);
		this.state = this.props.client;
	}

	onNewClient = (user) => {
		console.log('ClientLinkForm onNewUser:', user)
		this.setState({biopedClientId: user.clientId});
		this.saveLink(user.clientId);
	}

	onSaveLink = () => {
		console.log('onSaveLink');
		if(this.state.isBusy)return;
		this.setState({isBusy: true});
		this.saveLink(this.state.biopedClientId);
	}

	saveLink = (clientId) => {
		console.log('saveLink clientId:', clientId);
		ExtAppService.LinkPatient(this.props.client, clientId).then((resp) => {
			console.log('onSaveLink:', resp);

		}).finally(() => {
			this.setState({isBusy: false});
			if(this.props.onSave) {
				this.props.onSave();
			}
		})
	}

	render() {
		const client = this.state;// this.props.client;
		const form = new FormDataObj({name: `${client.clientFirstName} ${client.clientLastName}`, ...client});
		return (
			<div className={SanitizeClassNames(this, 'client-link-form')}>
				<FormLabeledItem label={'Client Name'}>
					<Input name='name' form={form} tabIndex={1} disabled/>
				</FormLabeledItem>
				<FormLabeledItem label={'Email'}>
					<Input name='clientEmail' form={form} tabIndex={1} disabled/>
				</FormLabeledItem>
				<FormLabeledItem label={'Cell Phone'}>
					<Input name='clientPhoneNumber' valueFormatter={Helper.Phone.FormatNumber} form={form} tabIndex={1} disabled/>
				</FormLabeledItem>
				<div className={'opts'}>
					<ClinicPatientList
						placeholder="Link Client"
						focus={true}
						required
						isCreatable={true}
						name='biopedClientId'
						form={form}
						value={client.biopedClientId}
						onOptionSelect={(data) => {
							this.setState({biopedClientId: data.clientId})
						}}
					/>
					<Button className='white' caption={'Create New Client'} onClick={() => {
						ShowCreateNewClient(
							{
								client: {
									firstName: client.clientFirstName,
									lastName: client.clientLastName,
									email: client.clientEmail,
									cellPhone: Helper.Phone.FormatNumber(client.clientPhoneNumber)
								},
								onSaved: this.onNewClient
							}
						);
					}}/>
				</div>
				{client.biopedClientId? <Button className={'save-link-btn green'} caption={'Save Link'} onClick={this.onSaveLink} isBusy={this.state.isBusy} />: null}
			</div>
		)
	}
}

const ShowCreateNewClient = ({client, onSaved}) => {

	const modalId = RootModal.ShowModal(<UserMiniForm user={client} onSaved={(user) => {
		if (onSaved) {
			onSaved(user);
		}
		RootModal.CloseModal(modalId);
	}} />, null, {
		onRequestClose: () => {
			RootModal.CloseModal(modalId);
		},
		title: (
			<div className={'modal-title'}>
				<span className={'align-left'}>Create New Client</span>
				<span className={'text-btn'} onClick={() => RootModal.CloseModal(modalId)}>Cancel</span>
			</div>
		),
		className: "client-link-form-modal"
	})
}



// WEBPACK FOOTER //
// ./src/views/Clients/forms/ClientLinkForm.jsx